import { List as ImmutableList, Map as ImmutableMap } from 'immutable'

import type { GiftItem, ProductItem, RecipeItem, UserOrder } from 'utils/types/order'

export function getUserOrderById(
  orderId: string,
  userOrders: ImmutableList<UserOrder> = ImmutableList<UserOrder>(),
) {
  return userOrders.find((order) => order?.get('id') === orderId, null, ImmutableMap())
}

export function getUserOrderProductIds(userOrder: UserOrder = ImmutableMap()) {
  const productItems = userOrder.get('productItems', ImmutableList<ProductItem>())

  return productItems.map((productItem) => productItem?.get('itemableId')).toArray()
}

export function getUserOrderGiftProductIds(userOrder: UserOrder = ImmutableMap()) {
  const giftItems = userOrder.get('giftItems', ImmutableList<GiftItem>())

  return giftItems
    .filter((item) => item?.get('itemableType') === 'Product')
    .map((item) => item?.get('itemableId'))
    .toArray()
}

export function getUserOrderRecipeUuIds(userOrder: UserOrder = ImmutableMap()) {
  const recipeItems = userOrder.get('recipeItems', ImmutableList<RecipeItem>())

  return recipeItems.map((recipeItem) => recipeItem?.get('recipeUuid')).toArray()
}
